<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div class="col-lg-12">
				<div class="card card-danger ">
					<div class="card-header">
						Manage Delivery Partners
						<button class="btn btn-primary float-right" @click="addPrompt">Add Partner</button> 
					</div>
					<div class="card-body overflow-auto">
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th scope="col">Name</th>
									<th scope="col">Address</th>
									<th scope="col">Tax ID</th>
									<th scope="col">Reg. No.</th>
									<th scope="col">Reg. Type</th>
									<th scope="col">Phone</th>
									<th scope="col">Email</th>
									<th scope="col">Place of Supply</th>
									<th scope="col">Validity</th>
									<th scope="col">Change</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="partner in delivery_partners">
									<td>{{partner.name}}</td>
									<td>{{partner.address_line_1}}, {{partner.address_line_2}}, {{partner.address_line_3}}, {{partner.city}}, {{partner.state}}, {{partner.country}}, {{partner.pincode}}</td>
									<td>{{partner.tax_id}}</td>
									<td>{{partner.reg_no}}</td>
									<td>{{partner.reg_type}}</td>
									<td>{{partner.phone}}</td>
									<td>{{partner.email}}</td>
									<td>{{partner.place_of_supply}}</td>
									<td>{{partner.validity}}</td>
									<td>
										<button class="btn btn-danger fa fa-square" v-if="partner.validity == 'Active'" @click="changePartner(partner.id, 'Inactive')"></button>
										<button class="btn btn-success fa fa-play" v-else @click="changePartner(partner.id, 'Active')"></button>
										<button class="btn btn-success" @click="view(partner.id)">View</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<pagination :pagination="pagination"
						 	@prev="getPartners(pagination.prevPageUrl)"
						  @next="getPartners(pagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>
<!-- row end -->
    </section>
    <!-- /.content -->

<div class="modal" tabindex="-1" role="dialog" id="addModal">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				Add Delivery Partner
			</div>
			<div class="modal-body">
				<div class="form-group">
					<label>Name</label>
					<input type="text" class="form-control" placeholder="Enter the name of the delivery partner" v-model="form.name">
					<span v-if="errors.name" :class="['badge bg-danger']">Please enter a valid name.</span>
				</div>
				<div class="form-group">
					<label>Branch</label>
					<v-select v-model="form.branch" class="form-control" type="text" label="fullname" :options="branches" :reduce="branches => branches.branch_code" name="branch" placeholder="Select Branch" :value="branches => branches.branch_code"></v-select>
					<span v-if="errors.branch" :class="['badge bg-danger']">Please choose a valid branch.</span>
				</div>
				<div class="form-group">
					<label>Address Line 1</label>
					<input type="text" class="form-control" placeholder="Enter the address line 1" v-model="form.address_line_1">
					<span v-if="errors.address_line_1" :class="['badge bg-danger']">Please enter a valid line.</span>
				</div>
				<div class="form-group">
					<label>Address Line 2</label>
					<input type="text" class="form-control" placeholder="Enter the address line 2" v-model="form.address_line_2">
					<span v-if="errors.address_line_2" :class="['badge bg-danger']">Please enter a valid line.</span>
				</div>
				<div class="form-group">
					<label>Address Line 3</label>
					<input type="text" class="form-control" placeholder="Enter the address line 3" v-model="form.address_line_3">
					<span v-if="errors.address_line_3" :class="['badge bg-danger']">Please enter a valid line.</span>
				</div>
				<div class="form-group">
					<label>City</label>
					<input type="text" class="form-control" placeholder="Enter the city" v-model="form.city">
					<span v-if="errors.city" :class="['badge bg-danger']">Please enter a valid city.</span>
				</div>
				<div class="form-group">
					<label>State</label>
					<input type="text" class="form-control" placeholder="Enter the state" v-model="form.state">
					<span v-if="errors.state" :class="['badge bg-danger']">Please enter a valid state.</span>
				</div>
				<div class="form-group">
					<label>Country</label>
					<input type="text" class="form-control" placeholder="Enter the country" v-model="form.country">
					<span v-if="errors.country" :class="['badge bg-danger']">Please enter a valid country.</span>
				</div>
				<div class="form-group">
					<label>Pincode</label>
					<input type="number" class="form-control" placeholder="Enter the pincode" v-model="form.pincode">
					<span v-if="errors.pincode" :class="['badge bg-danger']">Please enter a valid pincode.</span>
				</div>
				<div class="form-group">
					<label>Tax ID</label>
					<input type="text" class="form-control" placeholder="Enter the tax ID" v-model="form.tax_id">
					<span v-if="errors.tax_id" :class="['badge bg-danger']">Please enter a valid tax id.</span>
				</div>
				<div class="form-group">
					<label>Reg. No.</label>
					<input type="text" class="form-control" placeholder="Enter the reg. no." v-model="form.reg_no">
					<span v-if="errors.reg_no" :class="['badge bg-danger']">Please enter a valid reg. no.</span>
				</div>
				<div class="form-group">
					<label>Reg. Type</label>
					<input type="text" class="form-control" placeholder="Enter the reg. type" v-model="form.reg_type">
					<span v-if="errors.reg_type" :class="['badge bg-danger']">Please enter a reg. type.</span>
				</div>
				<div class="form-group">
					<label>Phone</label>
					<input type="number" class="form-control" placeholder="Enter the phone number" v-model="form.phone" min="1000000000">
					<span v-if="errors.phone" :class="['badge bg-danger']">Please enter a valid phone.</span>
				</div>
				<div class="form-group">
					<label>Email</label>
					<input type="email" class="form-control" placeholder="Enter the email" v-model="form.email">
					<span v-if="errors.email" :class="['badge bg-danger']">Please enter a valid email.</span>
				</div>
				<div class="form-group">
					<label>Place of Supply</label>
					<v-select :options="states" placeholder="Enter the place of supply" label="name" :reduce="states => states.state_code" v-model="form.place_of_supply"></v-select>
					<span v-if="errors.place_of_supply" :class="['badge bg-danger']">Please enter a valid place of supply.</span>
				</div>
				<div class="form-group">
					<button class="btn btn-primary" @click="addPartner">Submit</button>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {pagination: Pagination},
        
        created(){
        	this.getPartners();
        	this.getStates();
        	this.getBranches();
        },
        
        data(){
        	return {
        		delivery_partners: [],
        		errors: [],
        		form: new Form({
        			name: '',
        			address_line_1: '',
        			address_line_2: '',
        			address_line_3: '',
        			pincode: '',
        			city: '',
        			state: '',
        			country: '',
        			pincode: '',
        			tax_id: '',
        			reg_no: '',
        			reg_type: '',
        			phone: '',
        			email: '',
        			place_of_supply: '',
        			branch: ''
        		}),
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		
         		states: [],
         		branches: []
        	}
        },
        
        methods: {
        	getPartners(url="/api/getDeliveryPartners"){
        		axios.post(url)
        		.then(response => {
        			this.delivery_partners = response.data.data.data;
        			this.configPagination(response.data.data);
        		})
        	},
        	
        	getBranches(){
        		axios.post('/api/getSAPBranches')
        		.then(response => {
        			this.branches = response.data;
        		});
        	},
        	
        	getStates(){
        		axios.post("/api/getStates", {country: 101})
        		.then(response => {
        			this.states = response.data;
        		})
        	},
        	
        	configPagination(data){
      			this.pagination.lastPage=data.last_page;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},
    			
    			addPrompt(){
    				$("#addModal").modal("show");
    			},
    			
    			addPartner(){
    				this.form.post("/api/addDeliveryPartner")
    				.then(() => {
    					this.errors = [];
    					toast.fire({
    						icon: 'success',
    						title: 'Delivery Partner Added'
    					});
    					this.getPartners();
    				})
    				.catch((errors) => {
    					this.errors = errors.response.data.errors;
    				})
    			},
    			
    			view(id){
    				this.$router.push({name: 'Delivery Partner Profile | Master', params: {id: id}});
    			},
    			
    			changePartner(id, status){
    				axios.post('/api/changeDeliveryPartner', {id:id, status:status})
    				.then(() => {
    					this.getPartners();
    				})
    			},
        }
    }
</script>
